import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './error-page/error-page.component';
import { ViefyChangeEmailComponent } from './viefy-change-email/viefy-change-email.component';
import { AdminGuard } from './_services/admin-gaurd';
import { CustomerGuard } from './_services/customer-gaurd';
import { SupplierGuard } from './_services/supplier-gaurd';
import { UnauthGuard } from './_services/unauth-gaurd';
import { CustomOrderProcessingComponent } from './custom-order-processing/custom-order-processing.component';
import { CallbackComponent } from './callback/callback.component';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

const routes: Routes = [
  // {
  //   path: 'auth',
  //   loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  //   canActivate: [UnauthGuard],
  // },
  { path: 'callback', component: CallbackComponent },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./customer/customer.module').then((m) => m.CustomerModule),
    canActivate: [CustomerGuard],
  },
  { path: 'error', component: ErrorComponent },
  { path: 'custom-order-processing', component: CustomOrderProcessingComponent },

  { path: 'vierfychangeemail', component: ViefyChangeEmailComponent },
  {
    path: '',
    loadChildren: () =>
      import('./supplier/supplier.module').then((m) => m.SupplierModule),
    canActivate: [SupplierGuard],
  },
  // { path: '**', redirectTo: 'auth', pathMatch: 'full' },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
